var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button } from 'antd';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { haltClickEventPropagation } from '@lib/events';
import React from 'react';
import { ConfirmDelete } from './ConfirmDelete';
export const ConfirmDeleteButton = (_a) => {
    var { buttonClassName, buttonId, buttonLabel = COPY_SPECIFIC.DELETE, disabled, type = 'default' } = _a, rest = __rest(_a, ["buttonClassName", "buttonId", "buttonLabel", "disabled", "type"]);
    return React.createElement(ConfirmDelete, Object.assign({}, rest),
        React.createElement(Button, { className: classNames('delete-button', buttonClassName), danger: true, disabled: disabled, id: buttonId, onClick: haltClickEventPropagation, type: type }, buttonLabel));
};
